import React from 'react';
import RutabDesktopNavigationItem from './RutabDesktopNavigationItem';
import { useSelector } from 'react-redux';

const RutabDesktopNavigation = () => {
    const contentLinks = useSelector((state) => state.navigation.contentLinks);
    const languageSelector = useSelector((state) => state.navigation.languageTextEditor)

    return <RutabDesktopNavigationItem links={contentLinks} languageSelector={languageSelector} />;
};

export default RutabDesktopNavigation;
